import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useLocation,
} from "react-router-dom";
import { Login } from "./components/Login/Login";
import styled from "styled-components";
import { Home } from "./components/Home/Home";
import { useAuth } from "./context/AuthContext";
import { Invitations } from "./components/Invitations/Invitations";
import { Header } from "./components/common/Header/Header";
import { Organizations } from "./components/Organizations/Organizations";
import { Navbar } from "./components/Navbar/Navbar";
import { Logs } from "./components/Logs/Logs";
import { AnswerLogs } from "./components/Logs/AnswerLogs/AnswerLogs";
import { KbIngestionLogs } from "./components/Logs/KbIngestionLogs/KbIngestionLogs";
import { AnswerDetails } from "./components/Logs/AnswerLogs/AnswerDetails/AnswerDetails";
import { Test } from "./components/Test/Test";
import { BlockTest } from "./components/BlockTest/BlockTest";
import { BlockTestCreate } from "./components/BlockTestCreate/BlockTestCreate";
import { useEffect } from "react";

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

const App = () => {
  const { isAuthenticated } = useAuth();

  const ProtectedRoute = ({ children }) => {
    return isAuthenticated ? children : <Navigate to="/login" />;
  };

  return (
    <AppContainer>
      <Router>
        <ScrollToTop />
        {isAuthenticated ? (
          <AppLayout>
            <Header title="Dashboard" />
            <Navbar />
            <MainContent>
              <Routes>
                <Route
                  path="/invitations"
                  element={
                    <ProtectedRoute>
                      <Invitations />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/organizations"
                  element={
                    <ProtectedRoute>
                      <Organizations />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/logs"
                  element={
                    <ProtectedRoute>
                      <Logs />
                    </ProtectedRoute>
                  }
                >
                  <Route path="answers" element={<AnswerLogs />} />
                  <Route
                    path="knowledge-base-ingestions"
                    element={<KbIngestionLogs />}
                  />
                  <Route
                    index
                    element={<Navigate to="/logs/answers" replace />}
                  />
                </Route>
                <Route
                  path="/logs/answers/:answerId"
                  element={
                    <ProtectedRoute>
                      <AnswerDetails />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/test"
                  element={
                    <ProtectedRoute>
                      <Test />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/block-test"
                  element={
                    <ProtectedRoute>
                      <BlockTest />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/block-test/new"
                  element={
                    <ProtectedRoute>
                      <BlockTestCreate />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/block-test/:id"
                  element={
                    <ProtectedRoute>
                      <BlockTestCreate />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/"
                  element={
                    <ProtectedRoute>
                      <Home />
                    </ProtectedRoute>
                  }
                />
                <Route path="*" element={<Navigate to="/" />} />
              </Routes>
            </MainContent>
          </AppLayout>
        ) : (
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="*" element={<Navigate to="/login" />} />
          </Routes>
        )}
      </Router>
    </AppContainer>
  );
};

const AppContainer = styled.div`
  font-family: "Manrope", sans-serif;
  color: #0c0c0e;
  font-weight: 500;
  box-sizing: border-box;
  min-height: 100vh;
  display: flex;
  justify-content: center;
`;

const AppLayout = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  width: 83vw;
  margin: auto;
  padding: 1.5rem 0px;
`;

const MainContent = styled.main`
  flex: 1;
`;

export default App;
